import { render, staticRenderFns } from "./CustomBreakoutNavigation.vue?vue&type=template&id=4b23bf88&scoped=true&"
import script from "./CustomBreakoutNavigation.vue?vue&type=script&lang=js&"
export * from "./CustomBreakoutNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b23bf88",
  null
  
)

export default component.exports